import { atom } from 'jotai';

export const pmCountryAtom = atom<string | null>(null);
